import { render, staticRenderFns } from "./FiltersUnits.vue?vue&type=template&id=dca3ff5e&scoped=true"
import script from "./FiltersUnits.vue?vue&type=script&lang=js"
export * from "./FiltersUnits.vue?vue&type=script&lang=js"
import style0 from "./FiltersUnits.vue?vue&type=style&index=0&id=dca3ff5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca3ff5e",
  null
  
)

export default component.exports